<template>
	<div>
		<a-modal v-show='!ishand' id='warp_sim' width='25rem' v-model="visible" on-ok="handleOk1"
			v-dragModal class='myfus'
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'>
				<div
					style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 25rem;text-align: center;">
					{{visible1?(form.bs_flag=='B'?'買入委託確認':'賣出委託確認'):'現金交易'}}
				</div>
				<!-- <div style="">條件訂單</div> -->
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="height: 31rem;border-radius: 0 0 10px 10px;"
				:style="{backgroundColor: form.bs_flag == 'S'?'#fff0f0':'#ecfdff'}">
				<div v-show='!visible1' style="width: 70%;margin: 0 auto;padding-top: 1.5rem;">
					<a-form-model ref='ruleForm' :model="form" labelAlign='right' layout="horizontal" :rules='rules'
						hideRequiredMark :label-col="labelCol" :wrapper-col="wrapperCol">
						<a-form-model-item label='股票名稱'>
							<span v-if='form.reference'>{{form.reference}}</span>
						</a-form-model-item>
						<a-form-model-item label='市場' prop='exchange_code'>
							<a-select v-model="form.exchange_code" class='warp_width' @change='handf()'>
								<a-select-option v-for="(item) in Arr1" :key="item.key+'a'" :value="item.value">
									{{item.text }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item label='買/沽' prop='bs_flag'>
							<a-select v-model="form.bs_flag" class='warp_width'>
								<a-select-option v-for="(item) in admintypeArrs" :key="item.key+'a'"
									:value="item.value">{{england=="cn" ?item.text : item.entext}}</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item label='訂單類型' prop='order_type'>
							<a-select v-model="form.order_type" class='warp_width' @change='handz'>
								<a-select-option v-for="(item,index) in admintypeArr"
									v-if="form.exchange_code == 'HKEX'?index>0:index==0" :key="item.key+'a'"
									:value="item.value">{{item.text}}</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item label='股票編號' prop='product_code'>
							<a-input v-model="form.product_code" class='warp_width' @input='getdata' />
						</a-form-model-item>
						<a-form-model-item label='價格' prop='price'>
							<a-input v-model="form.price" style='width: 8.2rem;' @input="fannum()" />
							<div class='warp_btn' style="background-color: #3bc7a1;" @click='addnum("price",0)'>-</div>
							<div class='warp_btn' style="background-color: #ffa647;" @click='addnum("price",1)'>+</div>
						</a-form-model-item>
						<a-form-model-item label='數量' prop='qty'>
							<a-input v-model="form.qty" style='width: 8.2rem;' @input="qtyFn" />
							<div class='warp_btn' style="background-color: #3bc7a1;" @click='pulnum("qty",0)'>-</div>
							<div class='warp_btn' style="background-color: #ffa647;" @click='pulnum("qty",1)'>+</div>
						</a-form-model-item>
					</a-form-model>
					<!-- maxfan() -->
					<div class='warp_btn pos_ste' @click='fourFn(1)'>MAX</div>
					<div style="text-align: center;margin-top: -1rem;margin-bottom: 1.5rem;">
						<button class='btnfour' @click='fourFn(1)'
							:style='{backgroundColor:fourthqty=="1"?"#ffa647":""}'>全倉</button>
						<button class='btnfour' @click='fourFn(2)'
							:style='{backgroundColor:fourthqty=="2"?"#ffa647":""}'>半倉</button>
						<button class='btnfour' @click='fourFn(3)'
							:style='{backgroundColor:fourthqty=="3"?"#ffa647":""}'>1/3</button>
						<button class='btnfour' @click='fourFn(4)'
							:style='{backgroundColor:fourthqty=="4"?"#ffa647":""}'>1/4</button>
					</div>
					<div style="text-align: center;">
						<button class='btn1 btnx' @click='nextfn'>
							<!-- 下單 -->
							{{form.bs_flag=='B'?'買入':'沽出'}}
						</button>
						<button class='btn1 btn2' @click='resetForm("ruleForm")'>清除</button>
					</div>
				</div>
				<div v-if="visible1" style="width: 70%;margin: 0 auto;">
					<div style="width: 88%;margin: 0 auto;">
						<div class="warp_min warp_titlis">市場</div>
						<div class="warp-right warp_min">
							<img :src="backfn('img')" alt="" style="width: 1.4rem;margin-bottom: .15rem;">
							{{backfn('text')}}
						</div>
						<div class="warp_min warp_titlis">證券帳號</div>
						<div class="warp-right warp_min">
							1000005
						</div>
						<div class="warp_min warp_titlis">代碼</div>
						<div class="warp-right warp_min">
							{{form.product_code+'.'+backfn('gucode')}}
						</div>
						<div class="warp_min warp_titlis">名稱</div>
						<div class="warp-right warp_min">
							{{form.reference}}
						</div>
						<span class="warp_min warp_titlis">價格</span>
						<div class="warp-right warp_min">{{backfn('gumoney')+ ' ' + fanjiebao(form.price)}}
						</div>
						<span class="warp_min warp_titlis">數量</span>
						<div class="warp-right warp_min">
							{{fanjiebao(form.qty).split('.')[0]+' 股'}}
						</div>
						<span class="warp_min warp_titlis">總金額</span>
						<div class="warp-right warp_min"  :title='fanjiebao(form.price*form.qty)'
						:style="{lineHeight:fanjiebao(form.price*form.qty).length>=16? '1rem':''}">
							{{backfn('gumoney')+ ' ' + fanjiebao(form.price*form.qty)}}
						</div>
					</div>
					<div class="warp_min" style="text-align: center;width: 100%;color: #000;">
						您是否確認以上委託
					</div>
					<div style="margin-top: 2rem;display: flex;justify-content: space-between;margin-top: 2rem;">
						<button class='btn1 btnx' @click='handbect()'>確定</button>
						<button class='btn1 btn2' @click='visible1 = false'>取消</button>
					</div>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	export default {
		props: ['openstatic'],
		data() {
			return {
				fourthqty: '',
				visible1: false,
				labelCol: {
					span: 8
				},
				england: 'cn',
				wrapperCol: {
					span: 16
				},
				visible: true,
				ishand: false,
				rules: {},
				form: {
					reference: '',
					enable_approval_warning: 'N',
					enable_price_warning: 'Y',

					exchange_code: 'HKEX',
					order_type: 'PL',
					client_acc_code: '1000005',
					qty: '', //數量
					price: '',//价钱
					product_code: '',//股票編號
					bs_flag: 'B',

					ip_address: '192.168.31.228',
					localized_name: 'Y', //固定
				},
				Arr1: [{
					text: '港股',
					gumoney: 'HKD',
					value: 'HKEX',
					gucode: 'HK',
					img: require('@/image/simu/HK.png'),
				}, {
					text: '美股',
					gumoney: 'USD', //自己用
					value: 'US',
					gucode: 'US',
					img: require('@/image/simu/US.png')
				}, {
					text: '澳洲',
					gumoney: 'AUD',
					value: 'AU',
					gucode: 'AU',
					img: require('@/image/simu/AU.png')
				}, {
					text: '日本',
					gumoney: 'JPY',
					value: 'JP',
					gucode: 'JP',
					img: require('@/image/simu/JP.png')
				}, {
					text: '新加坡',
					gumoney: 'SGD',
					value: 'SGX',
					gucode: 'SGX',
					img: require('@/image/simu/SGX.png')
				}],
				admintypeArrs: [{
						text: '買入',
						value: 'B'
					},
					{
						text: '沽出',
						value: 'S'
					}
				],
				admintypeArr: [{
					text: '限價盤',
					entext: 'Mainboard',
					value: 'PL'
				}, {
					text: '增強限價盤',
					entext: 'Mainboard',
					value: 'E'
				}, {
					text: '競價限價盤',
					entext: 'Mainboard',
					value: 'I'
				}],
			}
		},
		mounted() {
			if (this.openstatic.type == '11') {
				this.$set(this.form, 'exchange_code', 'HKEX')
			}
			if (this.openstatic.type == '12') {
				this.$set(this.form, 'exchange_code', 'US')
			}

			this.handz()
		},
		methods: {
			fanjiebao(val, to = 2, num = 1) {
				//金额转换 分->元 保留2位小数 并每隔3位用逗号分开 1,234.56
				var str = (val / num).toFixed(to) + '';
				var intSum = str.substring(0, str.indexOf(".")).replace(/\B(?=(?:\d{3})+$)/g, ','); //取到整数部分
				var dot = str.substring(str.length, str.indexOf(".")) //取到小数部分搜索
				var ret = intSum + dot;
				return ret;
				//输出结果->20,000.00
			},
			qtyFn() {
				this.form.qty = this.form.qty.replace(/[^\d]/g, '')
				this.fourthqty = ''
			},
			fourFn(val) {
				//價格，股票號
				if (!this.form.product_code) {
					// if(this.form.bs_flag == 'S'){
						App.oTool.warningT('請輸入正確的股票代碼');
						return
					// }
				}
				if (!this.form.price) {
					App.oTool.warningT('請輸入股票價格');
					return
				}
				this.fourthqty = val
				let uuid = this.uuid()

				this.$ajax({
					method: 'post',
					url:this.$api.getIpoWarehouse,
					data:{
						"token":this.$store.state.token,
						 "price":this.form.price,
						 "percang":this.fourthqty,
						 "exchange_code":this.form.exchange_code,
						 bs_flag:this.form.bs_flag,
						 product_code:this.form.product_code,
					}
					//  this.$api.adminurls,
					// contentType: '',
					// data: {
					// 	command: this.$axoisfix('buy_qty', obj, uuid),
					// 	language: 'big5',
					// 	msgnum: uuid,
					// 	token: "a557d703-ab58-4782-b873-67b526faa60e",
					// 	username: 1000005,
					// }http://192.168.31.219:8080/#/
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						// App.oTool.successT();
						// this.$set(this.form, 'qty', isNaN(res.data.message[val] * 1) ? '' : res.data.message[val] *
						// 	1)
						this.$set(this.form, 'qty', res.data.amount)
					} else {
						// App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			backfn(gucode) {
				let str = ''
				this.Arr1.map(ev => {
					if (ev.value == this.form.exchange_code) {
						str = ev[gucode]
					}
				})
				return str
			},
			//现价：Last
			// 数量：LotSize
			// 名称：Desp
			// 恒定价格加减：BidSpread （搜索不到的   为  0.01）
			// 恒定数量加减：LotSize     （搜索不到的   为   100）
			// 只有港股
			getdata() {
				if (this.form.exchange_code == 'HKEX' && this.form.product_code.length == 5) {
					// this.form.price = 1 //现价
					// this.form.qty = 100
					// this.form.BidSpread = .01
					// this.form.LotSize = 100
					// this.form.reference = '' //名称
					// this.$ajax({
					// 	method: 'post',
					// 	url: this.$api.getStockMsg,
					// 	contentType: '',
					// 	data: {
					// 		"username": "1000005",
					// 		"language": "big5",
					// 		"symbol": this.form.product_code,
					// 		"token": "a557d703-ab58-4782-b873-67b526faa60e",
					// 	}
					// }).then(res => {
					// 	if (res.data.qmiscode === 1000) {
					// 		// App.oTool.successT();
					// 		this.form.price = (res.data.Quote.Last * 1).toFixed(2) //现价
					// 		this.form.qty = res.data.Quote.LotSize
					// 		this.form.BidSpread = res.data.Quote.BidSpread || .01
					// 		this.form.LotSize = res.data.Quote.LotSize || 100
					// 		this.form.reference = res.data.Quote.Desp //名称
					// 	} else {
					// 		App.oTool.warningT(res.data.qmismsg);
					// 	}
					// })
				}
			},
			handf(val) {
				this.$emit('child', this.form.exchange_code == 'US' ? 12 : 11)
				this.handz()
				this.form.product_code = ''
				this.form.price = ''
				this.form.qty = ''
				this.form.reference=''
				this.form.LotSize = ''
				this.form.BidSpread = ''
			},
			//获取美国 香港当地时间
			handz(val) {
				this.fourthqty = ''
				if (this.form.exchange_code !== 'HKEX') {
					this.$set(this.form, 'order_type', 'PL')
					return
				}
				this.$set(this.form, 'order_type', '')
				//获取美国 香港当地时间
				let timeZone = this.form.exchange_code == 'US' ? "America/New_York" : "Asia/Hong_Kong"
				//獲取本地時間
				let str;
				if (9 < new Date().getHours() <= 16 || (9 == new Date().getHours() && new Date().getMinutes() >= 15)) {
					str = 'E'
				} else {
					str = 'I'
				}
				this.$set(this.form, 'order_type', str)
				return
				this.$ajax({
					method: 'post',
					url: this.$api.qmisgetTime,
					data: {
						"timeZone": timeZone
					}
				}).then(res => {
					if (res.data.time) {
						let str = ''
						//时间段(9：15 - 16：00  E) 之外 I
						if (9 < res.data.time.split(':')[0] <= 16 || (9 == res.data.time.split(':')[0] && res.data
								.time.split(':')[1] >= 15)) {
							str = 'E'
						} else {
							str = 'I'
						}
						this.$set(this.form, 'order_type', str)
						// App.oTool.successT();
					} else {
						// App.oTool.warningT(res.data.qmismsg);
					}
				})
				// }
			},
			//max数量
			maxfan() {
				// let obj = {
				// 	client_acc_code: '',
				// 	localized_name: '',
				// 	price: '',
				// 	exchange_code: "",
				// 	product_code: '',
				// }
				// for (let key in obj) {
				// 	obj[key] = this.form[key]
				// }
				// let uuid = this.uuid()

				// this.$ajax({
				// 	method: 'post',
				// 	url: this.$api.adminurls,
				// 	contentType: '',
				// 	data: {
				// 		command: this.$axoisfix('buy_qty', obj, uuid),
				// 		language: 'big5',
				// 		msgnum: uuid,
				// 		token: "a557d703-ab58-4782-b873-67b526faa60e",
				// 		username: 1000005,
				// 	}
				// }).then(res => {
				// 	if (res.data.qmiscode === 1000) {
				// 		// App.oTool.successT();
				// 		if (res.data.message.qty) {
				// 			this.$set(this.form, 'qty', res.data.message.qty)
				// 		}
				// 	} else {
				// 		// App.oTool.warningT(res.data.qmismsg);
				// 	}
				// })
			},
			addnum(key, add) {
				//美股默认数量 1  0.01
				if (add) {
					this.form[key] = ((this.form.BidSpread || 0.01) * 1 + this.form[key] * 1).toFixed(2)
				} else {
					if (this.form[key] * 1 - (this.form.BidSpread || 0.01) * 1 >= 0) {
						this.form[key] = (this.form[key] * 1 - (this.form.BidSpread || 0.01) * 1).toFixed(2)
						this.form[key] = this.form[key] < 0 ? 0 : this.form[key]
					}
				}
			},
			pulnum(key, add) {
				this.fourthqty = ''
				let num = this.form.exchange_code == 'HKEX' || this.form.exchange_code == 'JP' || this.form
					.exchange_code == 'SGX' ? '100' : '1'
				if (add) {
					this.form[key] = ((this.form.LotSize || num) * 1 + this.form[key] * 1)
				} else {
					if (this.form[key] * 1 - (this.form.LotSize || num) * 1 >= 0) {
						this.form[key] = (this.form[key] * 1 - (this.form.LotSize || num) * 1)
						this.form[key] = this.form[key] < 0 ? 0 : this.form[key]
					}
				}
			},
			nextfn() {
				if (this.form.price && this.form.product_code && this.form.qty) {
					this.visible1 = true
				} else {
					App.oTool.warningT('請輸入有效股票數據');
				}
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				if (this.openstatic.type == '11') {
					this.$set(this.form, 'exchange_code', 'HKEX')
				}
				if (this.openstatic.type == '12') {
					this.$set(this.form, 'exchange_code', 'US')
				}
				this.form.LotSize = ''
				this.form.BidSpread = ''
				this.form.reference = ''
				this.handz()
			},
			fannum() {
				if (isNaN(this.form.price)) {
					this.form.price = ''
				}
			},
			uuid() {
				var s = [];
				var hexDigits = "0123456789abcdef";
				for (var i = 0; i < 36; i++) {
					s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
				}
				s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
				s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
				s[8] = s[13] = s[18] = s[23] = "-";
				var uuid = s.join("");
				return uuid;
			},
			//下单
			handbect() {
				// let uuid = this.uuid()
				
				this.form.token = this.$store.state.token;
				this.$ajax({
					method: 'post',
					url: this.$api.trading,//this.$api.adminurls,
					data:this.form
					// contentType: '',
					// data: {
					// 	command: this.$axoisfix('order_action:Add', this.form, uuid),
					// 	language: 'big5',
					// 	msgnum: uuid,
					// 	token: "5efc2ed4-4b2e-4366-86e2-443a8fc369b1",
					// 	username: 1000005,
					// }
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						App.oTool.successT();
						this.$emit('child', 0)
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
					// this.$emit('child', 0)
				})
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {
				// let arr = {
				// 	msgnum = 7E6815 DB84464D02B839040F2711656C,
				// 	language = big5,
				// 	command =  ,
				// 	token = 98 ee5824 - 1 cb1 - 4 c8a - 86 ba - b08e48b3edd7
				// }
			}
		}
	}
</script>

<style lang="scss" >
	#warp_sim {
		.mark-file div {
				margin: 0 !important;
				padding: 0.7rem 1rem;
		}
		.ant-modal {
			top: 15vh;
		}

		.warp_min {
			vertical-align: top;
			width: 70%;
			height: 3rem;
			line-height: 3rem;
			font-size: 1rem;
			padding: .7rem 0;
			display: inline-block;
		}

		.warp_titlis {
			margin-right: .1rem;
			color: #000;
			width: 26.5%;
		}


		.warp-right {
			text-align: right;
		}

		.ant-modal-close-x {
			.anticon svg {
				color: #5cb1b9;
				position: relative;
				top: .8rem
			}
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}

		.ant-form-item label {
			font-size: 1rem !important;
		}

		.ant-input {
			font-size: 1rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: 1rem !important;
		}

		.ant-form-item-children {
			font-size: 1rem !important;
		}

		.warp_btn {
			cursor: pointer;
			width: 1.5rem;
			color: #fff;
			display: inline-block;
			margin: 0 .1rem;
			height: 1.5rem;
			line-height: 1.5rem;
			text-align: center;
			border-radius: 10px;
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}

		.btn1 {
			cursor: pointer;
			width: 5rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 1.5rem;
		}

		.btnfour {
			cursor: pointer;
			width: 3.5rem;
			height: 1.5rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 20px;
			margin-left: 0.8rem;
			background-color: #a6b7c4;
		}

		.btnx {
			background-color: #2a83dd;
		}

		.btn2 {
			background-color: #999999;
		}

		.pos_ste {
			position: relative;
			// width: 2rem;
			font-size: .6rem;
			background-color: #ee7171;
			top: -3rem;
			left: 1rem;
		}
	}
</style>
